import {connect} from "react-redux";
import ValetActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {addTaggedAlong} from "../../../../service/Dealer/action";
import {ratingSave} from "../../../../service/Dealer/action";
import {markAttendance} from "../../../../service/DCC/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {isUserCheckInForModule} from "../../../../service/Account/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    savedRating: state.Dealer.savedRating,
    attendance:state.DCC.attendance,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    userCheckInForModule:state.Dropdown.userCheckInForModule,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            addTaggedAlong,
            ratingSave,
            markAttendance,
            documentUploadUrlPublic,
            isUserCheckInForModule,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetActivityList);
